// 常量定义

export const TOKEN_STATUS = {
  ENABLED: 1,
  DISABLED: 2,
  EXPIRED: 3,
  EXHAUSTED: 4,
} as const

export const TOKEN_STATUS_TEXT: Record<number, string> = {
  1: '已启用',
  2: '已禁用',
  3: '已过期',
  4: '额度用尽',
}

export const USER_ROLE = {
  COMMON: 1,
  ADMIN: 10,
  ROOT: 100,
} as const

export const USER_ROLE_TEXT: Record<number, string> = {
  1: '普通用户',
  10: '管理员',
  100: '超级管理员',
}

export const USER_STATUS = {
  ENABLED: 1,
  DISABLED: 2,
} as const

export const CHANNEL_STATUS = {
  ENABLED: 1,
  MANUALLY_DISABLED: 2,
  AUTO_DISABLED: 3,
} as const

export const CHANNEL_STATUS_TEXT: Record<number, string> = {
  0: '未知',
  1: '已启用',
  2: '已禁用',
  3: '自动禁用',
}

export const LOG_TYPE = {
  ALL: 0,
  TOPUP: 1,
  CONSUME: 2,
  MANAGE: 3,
  SYSTEM: 4,
  ERROR: 5,
  REFUND: 6,
} as const

export const LOG_TYPE_TEXT: Record<number, string> = {
  0: '全部',
  1: '充值',
  2: '消费',
  3: '管理',
  4: '系统',
  5: '错误',
  6: '退款',
}

// 渠道类型：value 必须与后端 newapi/constant/channel.go 的 ChannelType* 枚举一致。
// 增删后端枚举时同步本表，否则新建渠道会写入错误的 type 并路由到错误的上游。
export const CHANNEL_TYPES = [
  { key: 1, value: 1, text: 'OpenAI', label: 'OpenAI', color: 'green' },
  { key: 2, value: 2, text: 'Midjourney Proxy', label: 'Midjourney Proxy', color: 'arcoblue' },
  { key: 3, value: 3, text: 'Azure OpenAI', label: 'Azure OpenAI', color: 'cyan' },
  { key: 4, value: 4, text: 'Ollama', label: 'Ollama', color: 'gray' },
  { key: 5, value: 5, text: 'Midjourney Proxy Plus', label: 'Midjourney Proxy Plus', color: 'blue' },
  { key: 6, value: 6, text: 'OpenAI Max', label: 'OpenAI Max', color: 'green' },
  { key: 7, value: 7, text: 'OhMyGPT', label: 'OhMyGPT', color: 'green' },
  { key: 8, value: 8, text: '自定义渠道', label: '自定义渠道', color: 'gray' },
  { key: 9, value: 9, text: 'AILS', label: 'AILS', color: 'blue' },
  { key: 10, value: 10, text: 'AI Proxy', label: 'AI Proxy', color: 'purple' },
  { key: 11, value: 11, text: 'Google PaLM2', label: 'Google PaLM2', color: 'orange' },
  { key: 12, value: 12, text: 'API2GPT', label: 'API2GPT', color: 'blue' },
  { key: 13, value: 13, text: 'AIGC2D', label: 'AIGC2D', color: 'blue' },
  { key: 14, value: 14, text: 'Anthropic Claude', label: 'Anthropic Claude', color: 'purple' },
  { key: 15, value: 15, text: '百度文心千帆', label: '百度文心千帆', color: 'blue' },
  { key: 16, value: 16, text: '智谱 ChatGLM（已弃用，请用 GLM-4V）', label: '智谱 ChatGLM', color: 'violet' },
  { key: 17, value: 17, text: '阿里通义千问', label: '阿里通义千问', color: 'red' },
  { key: 18, value: 18, text: '讯飞星火认知', label: '讯飞星火认知', color: 'magenta' },
  { key: 19, value: 19, text: '360 智脑', label: '360 智脑', color: 'arcoblue' },
  { key: 20, value: 20, text: 'OpenRouter', label: 'OpenRouter', color: 'green' },
  { key: 21, value: 21, text: '知识库：AI Proxy', label: '知识库：AI Proxy', color: 'purple' },
  { key: 22, value: 22, text: '知识库：FastGPT', label: '知识库：FastGPT', color: 'blue' },
  { key: 23, value: 23, text: '腾讯混元', label: '腾讯混元', color: 'cyan' },
  { key: 24, value: 24, text: 'Google Gemini', label: 'Google Gemini', color: 'orange' },
  { key: 25, value: 25, text: 'Moonshot', label: 'Moonshot', color: 'green' },
  { key: 26, value: 26, text: '智谱 GLM-4V', label: '智谱 GLM-4V', color: 'purple' },
  { key: 27, value: 27, text: 'Perplexity', label: 'Perplexity', color: 'blue' },
  { key: 31, value: 31, text: '零一万物', label: '零一万物', color: 'green' },
  { key: 33, value: 33, text: 'AWS Bedrock', label: 'AWS Bedrock', color: 'orangered' },
  { key: 34, value: 34, text: 'Cohere', label: 'Cohere', color: 'purple' },
  { key: 35, value: 35, text: 'MiniMax', label: 'MiniMax', color: 'green' },
  { key: 36, value: 36, text: 'Suno API', label: 'Suno API', color: 'purple' },
  { key: 37, value: 37, text: 'Dify', label: 'Dify', color: 'cyan' },
  { key: 38, value: 38, text: 'Jina', label: 'Jina', color: 'blue' },
  { key: 39, value: 39, text: 'Cloudflare', label: 'Cloudflare', color: 'gray' },
  { key: 40, value: 40, text: 'SiliconCloud', label: 'SiliconCloud', color: 'purple' },
  { key: 41, value: 41, text: 'Vertex AI', label: 'Vertex AI', color: 'blue' },
  { key: 42, value: 42, text: 'Mistral AI', label: 'Mistral AI', color: 'blue' },
  { key: 43, value: 43, text: 'DeepSeek', label: 'DeepSeek', color: 'blue' },
  { key: 44, value: 44, text: '嵌入模型：MokaAI M3E', label: 'MokaAI M3E', color: 'purple' },
  { key: 45, value: 45, text: '字节火山方舟、豆包通用', label: '火山方舟 / 豆包', color: 'blue' },
  { key: 46, value: 46, text: '百度文心千帆V2', label: '百度文心千帆V2', color: 'blue' },
  { key: 47, value: 47, text: 'Xinference', label: 'Xinference', color: 'blue' },
  { key: 48, value: 48, text: 'xAI', label: 'xAI', color: 'blue' },
  { key: 49, value: 49, text: 'Coze', label: 'Coze', color: 'blue' },
  { key: 50, value: 50, text: '可灵 Kling', label: '可灵 Kling', color: 'green' },
  { key: 51, value: 51, text: '即梦 Jimeng', label: '即梦 Jimeng', color: 'blue' },
  { key: 52, value: 52, text: 'Vidu', label: 'Vidu', color: 'purple' },
  { key: 53, value: 53, text: 'SubModel', label: 'SubModel', color: 'blue' },
  { key: 54, value: 54, text: '豆包视频', label: '豆包视频', color: 'blue' },
  { key: 55, value: 55, text: 'Sora', label: 'Sora', color: 'green' },
  { key: 56, value: 56, text: 'Replicate', label: 'Replicate', color: 'blue' },
  { key: 57, value: 57, text: 'Codex (OpenAI OAuth)', label: 'Codex', color: 'blue' },
]

export const CHANNEL_TYPE_MAP = CHANNEL_TYPES.reduce<Record<number, string>>((acc, item) => {
  acc[item.value] = item.text
  return acc
}, {})

// 分页默认配置
export const DEFAULT_PAGE_SIZE = 20

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]
